export enum Language {
  Slovak = 'sk',
  Czech = 'cz',
  English = 'en',
  German = 'de',
  Polish = 'pl',
}
